import React from "react";

function Main() {
  return (
    <>
      <main className="main-page">

        {/* =========================
            HEADER / LOGO
        ========================== */}
        <header className="header">
          <div className="header-container-main text-center p-2">
            <div className="logo-text">
              Vareprint
            </div>
          </div>
        </header>


        {/* =========================
            BANNER
        ========================== */}
        <section className="banner-section">
          <div className="banner">

            <img
              src="https://www.vareprint.com/static/media/Banner.be7d326ab2a5f7530da9.webp"
              alt="Vareprint Banner"
              className="banner-image"
            />

            {/* Overlay */}
            <div className="banner-overlay"></div>

            {/* Banner Content */}
            <div className="banner-content">
              <div>
                <p className="banner-welcome">
                  Welcome
                </p>

                <h1 className="banner-title">
                  Shop With Us
                </h1>
              </div>
            </div>

          </div>
        </section>


        {/* =========================
            RETAIL / CORPORATE
        ========================== */}
        <section className="experience-section">

          <div className="experience-container">

            <div className="experience-heading">

              <p className="experience-small-title">
                Choose Your Experience
              </p>

              <h2>
                How would you like to shop?
              </h2>

            </div>


            <div className="experience-grid">

              {/* ================= RETAIL ================= */}
              <button
                type="button"
                className="experience-card"
              >

                <img
                  src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1000&q=85"
                  alt="Retail"
                  className="card-image"
                />

                <div className="card-overlay"></div>

                <div className="card-content">

                  <span className="card-title">
                    Retail
                  </span>

                  <span className="login-button">
                    Login
                  </span>

                </div>

              </button>


              {/* ================= CORPORATE ================= */}
              <button
                type="button"
                className="experience-card"
              >

                <img
                  src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1000&q=85"
                  alt="Corporate"
                  className="card-image"
                />

                <div className="card-overlay"></div>

                <div className="card-content">

                  <span className="card-title">
                    Corporate
                  </span>

                  <a
                    href="/login"
                    className="login-button"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Login
                  </a>

                </div>

              </button>

            </div>

          </div>

        </section>


        {/* =========================
            FOOTER
        ========================== */}
        <footer className="footer">

          <div className="footer-container">

            <div className="footer-grid">

              {/* Brand */}
              <div className="footer-brand">

                <h3>
                  VAREPRINT
                </h3>

                <p>
                  Quality products and services designed to make
                  your shopping experience simple and enjoyable.
                </p>

              </div>


              {/* Links */}
              <div className="footer-column">

                <h4>
                  Quick Links
                </h4>

                <div className="footer-links">

                  <a href="#">
                    Home
                  </a>

                  <a href="#">
                    Retail
                  </a>

                  <a href="#">
                    Corporate
                  </a>

                  <a href="#">
                    Contact
                  </a>

                </div>

              </div>


              {/* Contact */}
              <div className="footer-column">

                <h4>
                  Contact Us
                </h4>

                <div className="contact-details">

                  <p>
                    Email: info@vareprint.com
                  </p>

                  <p>
                    Phone: +91 98765 43210
                  </p>

                  <p>
                    Mumbai, Maharashtra, India
                  </p>

                </div>

              </div>

            </div>


            {/* Bottom */}
            <div className="footer-bottom">

              <p>
                © {new Date().getFullYear()} Vareprint.
                All rights reserved.
              </p>

              <div className="footer-policy-links">

                <a href="#">
                  Privacy Policy
                </a>

                <a href="#">
                  Terms & Conditions
                </a>

              </div>

            </div>

          </div>

        </footer>

      </main>
    </>
  );
}

export default Main;

